import React from 'react'
import Footer from '../components/Footer'
import HeroImages from '../components/HeroImages'
import Navbar from '../components/Navbar'
import Train from '../components/Train'

const Training = () => {
    return (
        <div>
            <Navbar />
            <HeroImages heading='Training' text='Pre-Flight & In-Flight Training' />
            <Train />
            <Footer />
        </div>
    )
}

export default Training